/**
 * Primitivas de UI. Van juntas en un archivo porque son chicas y cohesivas.
 *
 * Portadas del tablero de reuniones (web/src/components/ui.tsx), recortadas a las
 * dos que este tablero usa: sin orden por columna, sin paginación, sin botón de
 * copiar id. Las pills de estado de la pestaña Solicitudes son CSS puro (.pill en
 * table.scss), no un componente. El estado vacío vive dentro de cada tabla.
 *
 * Sin librería de componentes ni de iconos, igual que las apps hermanas: el CSP de
 * src/http.ts no permite CDNs de terceros.
 */

export function ErrorState({
  title = "Algo salió mal",
  message,
  onRetry,
}: {
  title?: string
  message: string
  onRetry?: () => void
}) {
  return (
    <div className="state-block state-error">
      <div className="state-title">{title}</div>
      <div>{message}</div>
      {onRetry && (
        <div className="state-actions">
          <button type="button" className="btn" onClick={onRetry}>
            Reintentar
          </button>
        </div>
      )}
    </div>
  )
}

/** Filas fantasma para la PRIMERA carga. En los refetch se sostiene la tabla anterior. */
export function SkeletonRows({ rows, cols }: { rows: number; cols: number }) {
  return (
    <>
      {Array.from({ length: rows }, (_, r) => (
        <tr key={r} className="skeleton-row">
          {Array.from({ length: cols }, (_, c) => (
            <td key={c}>
              <div className="skeleton-bar" style={{ width: `${45 + ((r + c) % 5) * 11}%` }} />
            </td>
          ))}
        </tr>
      ))}
    </>
  )
}
